export { default } from './Map.vue';
